import React from 'react';
import { ReactComponent as IconCheckMark } from '../../../assets/svg/whiteCheck.svg';
import Heading from '../../../generic-components/Heading';

const STYLES = {
  WRAPPER:
    'flex items-center box-border h-[71px] py-[12px] bg-bw00 hover:bg-bw02 px-[16px] border-[1px] rounded-[6px] mb-[12px]',
  TEXT_WRAPPER: 'flex w-full justify-between',
  TRANSFER_TYPE_TITLE: 'font-metricRMedium text-md text-action03 leading-6 ml-[4px]',
  TRANSFER_TYPE_ARRIVAL: 'font-metricR text-sm text-bw07 leading-5 flex w-full',
  TRANSFER_FEE: 'font-metricR text-md text-bw07 leading-6 flex items-center',
  TEXT_WRAPPER_MAIN: 'flex flex-wrap',
};

interface ITransferTypeProps {
  type: string;
  title: string;
  arrivalDate?: string;
  SVGIcon: any;
  onClick: (transferType: string) => void;
  isSelected: boolean;
  isLoading: boolean;
}

const TransferType = ({ type, title, arrivalDate, SVGIcon, onClick, isSelected, isLoading }: ITransferTypeProps) => (
  <div
    role='button'
    onClick={() => !isLoading && onClick(type)}
    onKeyDown={() => {}}
    tabIndex={0}
    data-testid={`TransferType-${title}`}
    className={`${STYLES.WRAPPER} ${isSelected ? 'border-action03' : 'border-bw04'} ${isLoading ? 'opacity-50' : ''}`}
  >
    <div
      className={`relative rounded-[50%] w-[20px] h-[20px] mr-[8px] ${isSelected ? 'action03' : 'bg-bw02 border border-bw03'}`}
    >
      {isSelected && (
        <div className='w-full h-full bg-action03 rounded-full flex items-center justify-center'>
          <IconCheckMark className='w-[10px] h-[10px]' />
        </div>
      )}
    </div>
    <div className={STYLES.TEXT_WRAPPER}>
      <div className={STYLES.TEXT_WRAPPER_MAIN}>
        <div className='flex items-center'>
          {SVGIcon && <SVGIcon />}
          <Heading title={title} className={STYLES.TRANSFER_TYPE_TITLE} />
        </div>
        <div className={STYLES.TRANSFER_TYPE_ARRIVAL}>{arrivalDate}</div>
      </div>
    </div>
  </div>
);

export default TransferType;
